/**
 * h5项目的通用js
 */

// 通用埋点统计 如：data-tongji="h5dh_djdh,点击电话"
import '../module/trace'
// cps用户时头部的推广工具条
import '../module/cps-extend-topbar'
// 微信分享 包含微信官方sdk和通用方法
import '../module/wx-share'
// 广告棱镜系统
// import '../module/prism'
// 头部下载行程大师提示
import '../module/dl-app'
// 页面收藏
import '../module/heart'
// 洋鼹鼠合作
import '../module/yangyanshu-head'



// WEBPACK FOOTER //
// ./src/pages/h5-commonjs.js